'use client';

import { IconChevronDown } from '@actr/icons/chevron-down';
import { Sizes, ThemeColorValueImportance } from '@actr/style/src/specs/theme-v2';
import { Button, ButtonSizes, ButtonTypes } from '@actr/ui/src/components/_atoms/button';
import { Space } from '@actr/ui/src/components/_atoms/space';
import { Text } from '@actr/ui/src/components/_atoms/text';
import { ContentBlock } from '@actr/ui/src/components/content-block';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';

import { SeoRecommendations } from '@/services/models/avia/recommendation';

import Recommendation from './recommendation';
import * as Styled from './style.css';

export type RecommendationsProps = {
  /** id для навигации - должен совпадать с ключом объекта, содержащего рек-ции в ответе api */
  id: string;
  /** список рекомендаций */
  recommendations: SeoRecommendations;
}

const Recommendations: React.FC<RecommendationsProps> = ({ id, recommendations }) => {
  const [recommendationsCount, setRecommendationsCount] = useState(4);
  const [hideShowMoreButton, setHideShowMoreButtonCount] = useState(false);

  function showMoreButton() {
    const newCount = recommendationsCount + 10;
    if (newCount >= (recommendations?.list || []).length) {
      setHideShowMoreButtonCount(true);
    }
    setRecommendationsCount(newCount);
  }

  return (
    <ContentBlock className={Styled.ContentBlock} id={id}>
      <Text tagName="h3" font="title.x2l">{recommendations!.title}</Text>
      <Space size={Sizes.X3S} />
      <Text color={ThemeColorValueImportance.LIGHTER} font="paragraph.m">{recommendations!.subtitle}</Text>
      <Space size={Sizes.S} />
      <Text font="paragraph.s">Не является офертой</Text>
      {recommendations!.list?.map((item, i) => <Recommendation key={i} recommendation={item} isHidden={i > recommendationsCount} />)}
      {!hideShowMoreButton && (
      <Button
        className={Styled.ShowMoreButton}
        onClick={showMoreButton}
        rightIcons={<IconChevronDown />}
        buttonType={ButtonTypes.TERTIARY}
        size={ButtonSizes.S}>
        Еще
      </Button>
      )}
    </ContentBlock>
  );
};

export default observer(Recommendations);
